module.exports = __webpack_public_path__ + "img/Toggle-On-Disabled.11eecb2e.svg";